import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { List } from "@planzone/dto";
import { useListsRetrieval, useListEdition } from "@planzone/view-models";

import { Props } from "./types";
import { ListEditionForm } from "./listEditionForm";
import styles from "./styles.scss";

function ListEdition(props: Props) {
  const filter = { limit: 999999999999, start: 0 };
  const [nextList, setNextList] = React.useState<List>(props.list);
  const { t } = useTranslation();
  const { lists, retrieveLists } = useListsRetrieval(props.project, filter);
  const { isRequestPending, editList } = useListEdition();

  React.useEffect(() => {
    retrieveLists({ project: props.project, filter });
  }, []);

  return (
    <div className={styles.listEdition}>
      <div className={styles.form}>
        <ListEditionForm
          formData={nextList}
          lists={lists.subLists}
          editForm={setNextList}
        />
      </div>
      <div className={styles.buttons}>
        <p className={styles.action} onClick={props.cancel}>
          {t("listEdition.cancel")}
        </p>
        <button
          disabled={isRequestPending}
          className={classNames(styles.button, styles.confirmationButton)}
          onClick={() =>
            !isRequestPending && editList({ list: props.list, nextList })
          }
        >
          {t("listEdition.submit")}
        </button>
      </div>
    </div>
  );
}

export { ListEdition };
